import * as marietta from "../../..";
import { Dialog } from "../../../core/view";
import * as THREE from 'three';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION } from "../../Constants";

const MESSAGE_SELECT_DIRECTION: string = '補正する方向を選択してください。';
const MESSAGE_CHANGE_TOO_SMALL: string = '入力された変更量が小さすぎるため補正できませんでした。';
const MESSAGE_CALIBRATION_ERROR: string = '補正処理中にエラーが発生しました。図面をご確認ください。';

export class CalibrationDialog extends Dialog {

    public targetWall: marietta.webcad.item.parts.Wall = null;

    private isXDirection = false;

    constructor(draggable: boolean) {
        super(draggable);
    }

    /**
     * HTML生成
     */
    public buildContent() {
        const id = 'CalibrationDialog';

        const title = (marietta.webcad.WebCADGlobal.language === 'jp') ? '寸法補正' : 'Dimension correction';

        let contents = '<div class="dialogCaribrationSetting">';
        contents += '<div class="explainCaribrationSetting">';
        contents += '<div id="xScaleExplain">';
        contents += '<p>横方向に、サイズ変更（伸縮）を行います。</p>';
        contents += '<p>縦方向チェックボックスを選択すると、縦方向のサイズ変更も同時に行います。</p>';
        contents += '</div>'; // xDirectionScale
        contents += '<div id="yScaleExplain">';
        contents += '<p>縦方向に、サイズ変更（伸縮）を行います。</p>';
        contents += '<p>横方向チェックボックスを選択すると、横方向のサイズ変更も同時に行います。</p>';
        contents += '</div>'; // yDirectionScale
        contents += '</div>'; // explainCaribrationSetting
        contents += '<table>';
        contents += '<tbody>';
        contents += '<tr>';
        contents += '<td><input type="checkbox" id="checkShowXDirection"></td>';
        contents += '<td><label><span class="jp">横方向に補正（x方向）</span><span class="en">Horizontal correction (x-direction)</span></label></td>';
        contents += '</tr>';
        contents += '<tr>';
        contents += '<td></td>';
        contents += '<td><input type="number" id="input_wall_x_before" disabled="disabled"><span class="comments">mm</span><span>　→　</span>';
        contents += '<input type="number" id="input_wall_x_after" min="0" disabled="disabled"><span class="comments">mm</span>';
        contents += '<span class="comments">（倍率<span id="xDirectionScale">100</span>%）</span></td>';
        contents += '</tr>';
        contents += '<tr>';
        contents += '<td><input type="checkbox" id="checkShowYDirection"></td>';
        contents += '<td><label><span class="jp">縦方向に補正（y方向）</span><span class="en">Vertical correction (y-direction)</span></label></td>';
        contents += '</tr>';
        contents += '<tr>';
        contents += '<td></td>';
        contents += '<td><input type="number" id="input_wall_y_before" disabled="disabled"><span class="comments">mm</span><span>　→　</span>';
        contents += '<input type="number" id="input_wall_y_after" min="0" disabled="disabled"><span class="comments">mm</span>';
        contents += '<span class="comments">（倍率<span id="yDirectionScale">100</span>%）</span></td>';
        contents += '</tr>';
        contents += '</tbody>';
        contents += '</table>';
        contents += '<div id="errorComment">';
        contents += '</div>';
        contents += '</div>';

        let footer = '<button id="btnOK"><span class="jp">OK</span><span class="en">OK</span></button>';
        footer += '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

        this.createDialog(id, title, contents, footer);

        document.querySelector('#CalibrationDialog #btnOK')?.addEventListener('click', this.onStartButtonClicked);
        document.querySelector('#CalibrationDialog #btnCancel')?.addEventListener('click', this.close);

        this.setValue();

        this.autoSettingValue();
        this.inputControl();
        this.settingScale();
        (<HTMLElement>document.getElementById('xScaleExplain')).style.display =  (this.isXDirection) ? 'block' : 'none';
        (<HTMLElement>document.getElementById('yScaleExplain')).style.display =  (this.isXDirection) ? 'none' : 'block';
    }

    /**
     * 自動入力部
     */
    private autoSettingValue() {
        const disbled = (e: Event, idName: string) => {
            (<HTMLInputElement>document.getElementById(idName)).disabled = !(<HTMLInputElement>e.currentTarget).checked;
        }

        const setValue = () => {
            const setUpParamID =  (this.isXDirection) ? 'y' : 'x';
            const setParamID = (this.isXDirection) ? 'x' : 'y';
            (<HTMLInputElement>document.getElementById(`input_wall_${setUpParamID}_after`)).value = (<HTMLInputElement>document.getElementById(`input_wall_${setParamID}_after`)).value;
            const beforeSize = (<HTMLInputElement>document.getElementById(`input_wall_${setUpParamID}_before`)).value;
            const afterSize = (<HTMLInputElement>document.getElementById(`input_wall_${setUpParamID}_after`)).value;
            const scale = (Number(afterSize) / Number(beforeSize) * 100)?.toFixed(3); // 小数第3位まで
            (<HTMLSpanElement>document.getElementById(`${setUpParamID}DirectionScale`)).innerHTML = (!(scale === 'NaN') && !(scale ==='Infinity')) ? scale.toString() : '';
        }

        document.getElementById('checkShowXDirection').addEventListener('click', (e) => {
            disbled(e, 'input_wall_x_after');
            if ((<HTMLInputElement>e.currentTarget).checked) {
                setValue();
            }
        });
        document.getElementById('checkShowYDirection').addEventListener('click', (e) => {
            disbled(e, 'input_wall_y_after');
            if ((<HTMLInputElement>e.currentTarget).checked) {
                setValue();
            }
        });

    }

    /**
     * 入力制御
     * マイナスの値等は許可しない
     */
    private inputControl() {
        const absolute = (e) => {
            const value = Math.abs( parseInt(e.currentTarget.value, 10) );
            e.currentTarget.value = (isNaN(value)) ? '' : value;
        }

        document.getElementById('input_wall_x_after').addEventListener("input", absolute);
        document.getElementById('input_wall_y_after').addEventListener("input", absolute);
    }

    /**
     * 倍率設定
     */
    private settingScale() {
        const scale = (e: Event, axis: string) => {
            const beforeSize = (<HTMLInputElement>document.getElementById(`input_wall_${axis}_before`)).value;
            const afterSize = (<HTMLInputElement>e.currentTarget).value;
            const scale = (Number(afterSize) / Number(beforeSize) * 100)?.toFixed(3); // 小数第3位まで
            (<HTMLSpanElement>document.getElementById(`${axis}DirectionScale`)).innerHTML = (!(scale === 'NaN') && !(scale ==='Infinity')) ? scale.toString() : '';
        }

        document.getElementById('input_wall_x_after').addEventListener('change', (e) => scale(e, 'x'));
        document.getElementById('input_wall_y_after').addEventListener('change', (e) => scale(e, 'y'));
    }

    /**
     * 値をセット
     */
    private setValue() {
        console.log(this.targetWall);

        const startDot = this.targetWall.startDot;
        const endDot = this.targetWall.endDot;

        const startVec = new THREE.Vector2(startDot.x, startDot.y);
        const endVec = new THREE.Vector2(endDot.x, endDot.y);

        const direction = endVec.clone().sub(startVec);
        const radiun = direction.clone().normalize().angle();

        // -180度 <= radiun < -135度 || - 45度 < radiun <  45度 || 135度 < radiun <= 180度 => x方向
        const isXDirection = ((- Math.PI <= radiun && radiun < - 3 * Math.PI / 4) || (- Math.PI / 4 < radiun && radiun < Math.PI / 4) || (3 * Math.PI / 4 < radiun && radiun <= Math.PI)) ?? false;
        (<HTMLInputElement>document.getElementById('checkShowXDirection')).checked = isXDirection;
        (<HTMLInputElement>document.getElementById('checkShowYDirection')).checked = !isXDirection;
        this.isXDirection = isXDirection;
        (<HTMLInputElement>document.getElementById('input_wall_x_after')).disabled = !isXDirection;
        (<HTMLInputElement>document.getElementById('input_wall_y_after')).disabled = isXDirection;

        // 壁の数値をセット
        const mmX = marietta.webcad.util.WebCADUtil.convertPixToMM(direction.x);
        const mmY = marietta.webcad.util.WebCADUtil.convertPixToMM(direction.y);
        const valueX = Math.round( Math.abs(mmX) );
        const valueY = Math.round( Math.abs(mmY) );
        (<HTMLInputElement>document.getElementById('input_wall_x_before')).value = valueX != 0 ? valueX.toString() : valueY.toString();
        (<HTMLInputElement>document.getElementById('input_wall_x_after')).value =  valueX != 0 ? valueX.toString() : valueY.toString();
        (<HTMLInputElement>document.getElementById('input_wall_y_before')).value = valueY != 0 ? valueY.toString() : valueX.toString();
        (<HTMLInputElement>document.getElementById('input_wall_y_after')).value =  valueY != 0 ? valueY.toString() : valueX.toString();
    }

    /**
     * 「OK」ボタンがクリックされた
     */
    private onStartButtonClicked = () => {
        const getInputValue = (idName: string) => (<HTMLInputElement>document.getElementById(idName)).value;
        const isChecked = (idName: string) => (<HTMLInputElement>document.getElementById(idName)).checked;

        if (!isChecked('checkShowXDirection') && !isChecked('checkShowYDirection')) {
            document.getElementById('errorComment').innerHTML = MESSAGE_SELECT_DIRECTION;
            return;
        }

        const isZero = () => (Number(getInputValue('input_wall_x_after')) === 0) || (Number(getInputValue('input_wall_y_after')) === 0);
        const isBlank = () => (getInputValue('input_wall_x_after')) === '' || (getInputValue('input_wall_y_after') === '');
        if (isZero() || isBlank()) {
            document.getElementById('errorComment').innerHTML = '0より大きい数値を入力してください。';
            return;
        }

        const xScale = Number(getInputValue('input_wall_x_after')) / Number(getInputValue('input_wall_x_before'));
        const yScale = Number(getInputValue('input_wall_y_after')) / Number(getInputValue('input_wall_y_before'));

        let scaleVector = new THREE.Vector2(1, 1);
        const isHouse = () => marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE;
        if (!isNaN(xScale)) scaleVector.x = isHouse() ? this.calculateNearestEighthMultiple(xScale) : xScale; // % → 倍率変換
        if (!isNaN(yScale)) scaleVector.y = isHouse() ? this.calculateNearestEighthMultiple(yScale) : yScale;

        if (!isChecked('checkShowXDirection')) scaleVector.x = 1;
        if (!isChecked('checkShowYDirection')) scaleVector.y = 1;

        // 1/8単位への丸め等により、チェックした方向の変更が実質無効化されていないか確認する
        const xIgnored = isChecked('checkShowXDirection') && !isNaN(xScale) && xScale !== 1 && scaleVector.x === 1;
        const yIgnored = isChecked('checkShowYDirection') && !isNaN(yScale) && yScale !== 1 && scaleVector.y === 1;
        if (xIgnored || yIgnored) {
            document.getElementById('errorComment').innerHTML = MESSAGE_CHANGE_TOO_SMALL;
            return;
        }

        try {
            this.resize(scaleVector);

            if ( marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
                marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
            }
            marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
            marietta.webcad.WebCADGlobal.quotationItemList.createData();
            marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
            marietta.webcad.WebCADGlobal.updateMeasureLine(false);
        } catch (e) {
            // 途中まで補正が適用された可能性がある状態でダイアログを残すと、
            // 再度OKを押されたときに同じ補正が二重に適用されてしまうため、
            // エラー時は必ずダイアログを閉じたうえで通知する。
            console.error(e);
            this.close();
            marietta.webcad.WebCADGlobal.showAlert(MESSAGE_CALIBRATION_ERROR);
            return;
        }

        this.close();
    }

    /**
     * リサイズ関数
     * 下絵：リサイズなし 配置位置調整
     * 敷地：リサイズあり（頂点座標の拡縮）
     * 部屋：リサイズあり（頂点座標の拡縮）
     * 階段：リサイズあり（頂点座標の拡縮）
     * 建具：リサイズあり 配置座標調整
     * 住設：リサイズなし 配置座標調整
     * 家具：リサイズなし 配置座標調整
     * 外構：リサイズなし 配置座標調整
     * 屋根：リサイズあり（頂点座標の拡縮）
     * 汎用：リサイズなし 配置座標調整
     * @param scale
     * @returns
     */
    private resize(scale: THREE.Vector2): void {
        if (scale.clone().equals(new THREE.Vector2(1, 1))) return; // 1倍の場合は補正しない

        const targetFloors: marietta.webcad.layer.FloorLayer[] = [];
        [1, 2, 3].forEach((floor: number) => {
            targetFloors.push( marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor) );
            targetFloors.push( marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(floor, true) );
        });
        if (targetFloors.length === 0) return;

        const basePoint = this.decideBasePoint(targetFloors);
        if (!basePoint) return;

        targetFloors.forEach((targetFloor) => {
            targetFloor.allLayers.forEach((itemLayer) => {
                itemLayer.getAllChildren().forEach((monicaObject) => {
                    if (!this.hasBoundRect(monicaObject)) return; // 上階階段(UpStair)等、MonicaObjectの契約を持たないアイテムは対象外（パートナーのStair側のスケーリングに追従する）
                    // スケーリング
                    this.scaling(monicaObject, basePoint, scale);
                    if (this.isShitae(monicaObject.itemInfo.id)) return;
                    monicaObject.reCreateImage();
                });
            })
        });
    }

    /**
     * getBoundRect() を持つ（MonicaObjectとしての契約を満たす）アイテムかどうか
     * 上階階段(UpStair)のように、レイヤーの子要素でありながらMonicaObjectを継承しないクラスが混在するため、
     * 基準点算出・スケーリングの対象から安全に除外するために使う。
     */
    private hasBoundRect(monicaObject: marietta.webcad.item.MonicaObject): boolean {
        return typeof monicaObject.getBoundRect === 'function';
    }

    /**
     * 間取りの縮尺 スケーリング
     */
    private scaling(monicaObject: marietta.webcad.item.MonicaObject, basePoint: THREE.Vector2, scale: THREE.Vector2): void {
        const getOffset = (x: number, y: number) => {
            const position = new THREE.Vector2(x, y);
            const direction = position.clone().sub(basePoint);
            direction.set(direction.x * scale.x, direction.y * scale.y);

            return direction;
        }

        const iteminfo = monicaObject.itemInfo;
        if (iteminfo.dotList && iteminfo.dotList.length > 0 && !this.isShitae(iteminfo.id)) {

            if (this.isStair(iteminfo.id)) { // 階段

                // 0度 <= rotation < 45度 || 135度 < rotation <  225度 || 315度 < rotation <= 360度
                const rotation = iteminfo.rotation;
                if ((0 <= rotation && rotation < 45) || (135 <= rotation && rotation < 225) || (315 <= rotation && rotation < 360)) {
                    (<marietta.webcad.item.Stair>monicaObject).changeSize(iteminfo.width * scale.x, iteminfo.height * scale.y);
                } else {
                    (<marietta.webcad.item.Stair>monicaObject).changeSize(iteminfo.width * scale.y, iteminfo.height * scale.x);
                }

            } else {

                iteminfo.dotList.forEach((point) => {
                    const position = new THREE.Vector2(point.x, point.y);
                    position.multiply(scale);
                    point.x = position.x;
                    point.y = position.y;
                });
            }

            if (this.isRoof(iteminfo.id)) { // 屋根
                const offset = getOffset(iteminfo.x, iteminfo.y);
                (<marietta.webcad.item.Roof>monicaObject).moveDots(offset.x + basePoint.x, offset.y + basePoint.y);
                return;
            }

            const offset = getOffset(iteminfo.x, iteminfo.y);
            monicaObject.move(offset.x + basePoint.x, offset.y + basePoint.y);

        } else {

            const offset = getOffset(iteminfo.x, iteminfo.y);
            monicaObject.move(offset.x + basePoint.x, offset.y + basePoint.y);

        }
    }

    /**
     * 基準点の確定：間取り全体の左下（下絵、敷地～汎用作図を含む）
     * @returns
     */
    private decideBasePoint(targetFloors: marietta.webcad.layer.FloorLayer[]): THREE.Vector2 {
        let rectangle: marietta.core.Rectangle = null;
        targetFloors.forEach((targetFloor) => {
            targetFloor.allLayers.forEach((itemLayer) => {
                itemLayer.getAllChildren().forEach((monicaObject) => {
                    if (!this.hasBoundRect(monicaObject)) return; // 上階階段(UpStair)等、MonicaObjectの契約を持たないアイテムは対象外
                    if (!rectangle) {
                        rectangle = monicaObject.getBoundRect();
                    } else {
                        rectangle = rectangle.union(monicaObject.getBoundRect()); // 合体
                    }
                });
            })
        });

        if (rectangle === null) return null;

        return new THREE.Vector2(rectangle.x, rectangle.y);
    }

    /**
     * 1/8単位での倍数を算出する
     * @param num
     * @returns
     */
    private calculateNearestEighthMultiple(num: number): number {
        return Math.round(num * 8) / 8;
    }

    public closeEvent() {
        this.targetWall?.highlight(false);

        super.closeEvent();
    }

    private isShitae(id: string) {
        return id.substring(0, 3) === marietta.webcad.Constants.MODE_SHITAE_KEY;
    }

    private isStair(id: string) {
        return id.substring(0, 3) === marietta.webcad.Constants.MODE_STAIR_KEY;
    }

    private isRoof(id: string) {
        return id.substring(0, 3) === marietta.webcad.Constants.MODE_ROOF_KEY;
    }

}
